var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('table', {
    staticClass: "table table-striped",
    staticStyle: {
      "border-bottom": "1px solid #dee2e6"
    }
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.runningHours, function (rh, engineIndex) {
    var _rh$power_type, _rh$power_series, _rh$power_series2;
    return _c('tr', {
      key: engineIndex
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(rh === null || rh === void 0 ? void 0 : (_rh$power_type = rh.power_type) === null || _rh$power_type === void 0 ? void 0 : _rh$power_type.name))]), _c('br'), _c('small', [_vm._v(_vm._s(rh === null || rh === void 0 ? void 0 : (_rh$power_series = rh.power_series) === null || _rh$power_series === void 0 ? void 0 : _rh$power_series.name) + " - " + _vm._s(rh === null || rh === void 0 ? void 0 : (_rh$power_series2 = rh.power_series) === null || _rh$power_series2 === void 0 ? void 0 : _rh$power_series2.model))])]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(_vm.formatDate(rh.last_rh_date)))]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(Number(rh === null || rh === void 0 ? void 0 : rh.this_month).toLocaleString()) + " Hours")]), _c('td', {
      staticClass: "text-truncate"
    }, [_vm._v(_vm._s(Number(rh === null || rh === void 0 ? void 0 : rh.total_running_hour).toLocaleString()) + " Hours")])]);
  }), 0)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-truncate",
    staticStyle: {
      "background-color": "#334697",
      "color": "white"
    }
  }, [_vm._v("Engine Name")]), _c('th', {
    staticClass: "text-truncate",
    staticStyle: {
      "background-color": "#334697",
      "color": "white"
    }
  }, [_vm._v("Lates Input RH (Date)")]), _c('th', {
    staticClass: "text-truncate",
    staticStyle: {
      "background-color": "#334697",
      "color": "white"
    }
  }, [_vm._v("Lates Input RH (Hours)")]), _c('th', {
    staticClass: "text-truncate",
    staticStyle: {
      "background-color": "#334697",
      "color": "white"
    }
  }, [_vm._v("Total RH")])])]);

}]

export { render, staticRenderFns }